import z from "zod/v4";
const doctorsIdSchema = z.string().transform((val) => val);
const secretariesIdSchema = z.string().transform((val) => val);
const doctorLimitedSchema = z.object({
    id: doctorsIdSchema,
    username: z.string(),
    fullname: z.string(),
    messagename: z.string(),
    organization_id: z.number(),
    tag: z.literal("doctor"),
    google_business_profile_id: z.string().nullable(),
});
const secretaryLimitedSchema = z.object({
    id: secretariesIdSchema,
    username: z.string(),
    fullname: z.string(),
    messagename: z.string(),
    organization_id: z.number(),
    tag: z.literal("secretary"),
});
export const userLimitedSchema = z.union([
    doctorLimitedSchema,
    secretaryLimitedSchema,
]);
//# sourceMappingURL=Users.js.map